import { render } from "./Configs.vue?vue&type=template&id=bf6e4076"
import script from "./Configs.vue?vue&type=script&lang=js"
export * from "./Configs.vue?vue&type=script&lang=js"

import exportComponent from "/go/src/asuzs/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__